import { BlockchainErrorParser } from '../model';
import type { WalletErrorType } from '../types';

export const parseBlockchainError = (error: WalletErrorType): string => {
  const errorMessage = BlockchainErrorParser.parse(error);

  console.error(errorMessage);

  return errorMessage;
};
